import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckerSelectIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 8,
			height: 8,
			x: 3,
			y: 3,
			fill: "currentColor",
			stroke: "none",
			opacity: .2,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 8,
			height: 8,
			x: 3,
			y: 3,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 8,
			height: 8,
			x: 13,
			y: 13,
			fill: "currentColor",
			stroke: "none",
			opacity: .2,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 8,
			height: 8,
			x: 13,
			y: 13,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 8,
			height: 8,
			x: 13,
			y: 3,
			opacity: .3,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 8,
			height: 8,
			x: 3,
			y: 13,
			opacity: .3,
			rx: 1
		})
	]
});
export default SvgCheckerSelectIcon;
